
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PostPolicy from "@/lib/model/gateway/post-policy";
import {
  ImageUploadAdapterPlugin,
  InlineEditor as CKEditor
} from "./ckeditor5";
// import "@ckeditor/ckeditor5-build-inline/build/translations/zh-cn";
// import CKEditor from "@ckeditor/ckeditor5-build-inline";
// import { InlineEditor as editor, ImageUploadAdapterPlugin } from "./ckeditor5";
import _ from "lodash-es";
declare const InlineEditor: CKEditor;

@Component
export default class Editor extends Vue {
  @Prop({ type: String, default: "" }) text!: string; //展示内容
  @Prop({ type: String, default: "" }) private readonly placeholder!: string;
  @Prop({ type: String, default: "default" }) keyIndex!: string; //key值  防重复
  @Prop({ type: String, default: "" }) offsetRight!: string; //工具栏右偏移量
  @Prop({ type: Boolean, default: true }) showUploadImage!: boolean; //暴露上传图片功能
  @Prop({ type: Boolean, default: false }) useThrottle!: boolean;
  name = "editor";
  // editor!: null | KEditor;
  editor!: null | CKEditor; //编辑器实例
  policyMap: _.Dictionary<PostPolicy> = {};
  seq: number[] = [];
  seqIdx = 0;

  @Watch("text") //入值
  initValue(to: string) {
    if (this.text !== String(this.editor?.getData())) {
      this?.editor?.setData(to);
    }
  }
  throttleId = 0;
  mounted() {
    this.initCKEditor();
  }
  open(clear?: any) {
    const t = clear === false ? this.text : ""; //赋值或清空
    this?.editor?.setData(t);
  }
  initCKEditor() {
    const toolbar = [
      "bold",
      "italic",
      "|",
      "alignment",
      "|",
      "bulletedList",
      "numberedList",
      "|",
      "imageResize"
    ];
    if (this.showUploadImage) toolbar.push("imageUpload");
    InlineEditor.create(this.$refs[this.keyIndex] as any, {
      // 配置图片功能栏
      image: {
        toolbar: [
          // "imageStyle:alignLeft",
          // "imageStyle:alignCenter",
          // "imageStyle:alignRight",
          // "|",
          // "resizeImage",
          // "|",
          // "imageTextAlternative"
        ],
        resizeOptions: [
          // {
          //   name: "resizeImage:original",
          //   label: "Original",
          //   value: null
          // },
          // {
          //   name: "resizeImage:50",
          //   label: "50%",
          //   value: "50"
          // },
          // {
          //   name: "resizeImage:75",
          //   label: "75%",
          //   value: "75"
          // }
        ]
        // styles: ["alignLeft", "alignCenter", "alignRight"]
      },
      language: "zh-cn",
      placeholder: this.placeholder,
      extraPlugins: [ImageUploadAdapterPlugin], //上传图片的适配器
      toolbar: toolbar
      // enterMode: CKEditor.ENTER_BR,
      // shiftEnterMode: CKEditor.ENTER_P,
    })
      .then((editor: any) => {
        const offsetRight = this.offsetRight;
        this.editor = editor; //将编辑器保存起来，用来随时获取编辑器中的内容等，执行一些操作
        this.editor?.setData(this.text);
        // if (this.useThrottle) {
        //   const model = editor.model;
        //   const doc = editor.model.document;
        //   doc.on("change:data", function() {
        //     const changes = doc.differ.getChanges();
        //     model.change(function(writer: any) {
        //       console.log(writer, "writer");
        //       for (let i = 0; i < changes.length; i++) {
        //         const entry = changes[i];
        //         if (entry.type == "insert" && entry.name == "paragraph") {
        //           const paragraph = entry.position.nodeAfter;
        //           writer.insertText(
        //             String.fromCharCode(8203),
        //             paragraph,
        //             "end"
        //           );
        //         }
        //       }
        //     });
        //     console.log(editor.getData(), "this.editor.getData()");
        //   });
        // }
        this.editor?.model.document.on("change:data", () => {
          if (this.useThrottle) {
            this.throttle(() => {
              this.$emit(
                "change",
                this.editor?.getData().replace(/\u200B/g, "")
              );
            });
            return;
          } else {
            this.$emit("change", this.editor?.getData());
          }
        });
        //工具栏初始化位置防抖
        editor.editing.view.document.on(
          "change:isFocused",
          (evt: unknown, data: unknown, isFocused: unknown) => {
            console.log(`View document is focused: ${isFocused}.`);
            this.$emit("isFocus", isFocused);
            if (isFocused) {
              const toolbars = document.getElementsByClassName(
                "ck-toolbar-container"
              );
              Array.prototype.forEach.call(toolbars, function(element) {
                element.classList.add("hidden-toolbar");
              });
              setTimeout(() => {
                Array.prototype.forEach.call(toolbars, function(element) {
                  element.classList.remove("hidden-toolbar");
                });
              }, 120);
              //工具栏位置调整
              Array.prototype.forEach.call(toolbars, function(element) {
                element.style.marginLeft = offsetRight;
              });
            }
          }
        );
      })
      .catch((error: any) => {
        console.error(error);
      });
  }
  throttle(method: any) {
    if (this.throttleId) {
      return;
    }
    method();
    this.throttleId = setTimeout(() => {
      this.throttleId = 0;
    }, 100);
  }
}
